import type { AutotraderConfig, environments } from "./types";

export const autotraderConfig: Record<environments, AutotraderConfig> = {
  local: {
    launchDarklyKey: "644841c41384731244c27357",
    newRelic: {
      accountID: "",
      trustKey: "",
      agentID: "",
      licenseKey: "",
      applicationID: ""
    },
    pendo: {
      apiKey: "53e0835b-8f53-4c01-45c0-e277be49f4d5"
    }
  },
  qa: {
    launchDarklyKey: "644841c41384731244c27357",
    newRelic: {
      accountID: "",
      trustKey: "",
      agentID: "",
      licenseKey: "",
      applicationID: ""
    },
    pendo: {
      apiKey: "53e0835b-8f53-4c01-45c0-e277be49f4d5"
    }
  },
  prod: {
    launchDarklyKey: "644841c41384731244c27358",
    newRelic: {
      accountID: "",
      trustKey: "",
      agentID: "",
      licenseKey: "",
      applicationID: ""
    },
    pendo: {
      apiKey: "53e0835b-8f53-4c01-45c0-e277be49f4d5"
    }
  }
};
